



















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { studentModule } from '@/store/modules/entities/student.module';
import { StudentCompetencyData } from '@/models/student/student-competency-data';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GTextView from '@/components/GTextView.vue';
import GCompetencyLabel from '@/components/GCompetencyLabel.vue';

@Component({
  name: 'GStudentRecordGrowthAdvice',
  components: { GCompetencyLabel, GTextView, GTopicSubject },
  computed: {},
  methods: {},
})
export default class GStudentRecordGrowthAdvice extends Vue {
  mounted() {}

  get studentCompetencyData(): StudentCompetencyData {
    return studentModule.studentCompetencyData;
  }
}
